<template>
  <transition name="loading-bar-fade">
    <div v-if="visible" class="loading-bar" :style="barStyle"></div>
  </transition>
</template>

<script setup>
import { ref, watch, onUnmounted, defineProps } from 'vue'

const props = defineProps({
  color: { type: String, default: '#FF7A00' },
  height: { type: String, default: '2px' },
  duration: { type: Number, default: 800 }, // ms
  show: { type: Boolean, default: false }
})

const visible = ref(false)
const barStyle = ref({})
let timer = null

watch(() => props.show, (val) => {
  if (val) {
    visible.value = true
    barStyle.value = {
      width: '0%',
      background: props.color,
      height: props.height
    }
    setTimeout(() => {
      barStyle.value = {
        ...barStyle.value,
        width: '90%',
        transition: `width ${props.duration}ms cubic-bezier(.4,0,.2,1)`
      }
    }, 10)
  } else {
    barStyle.value = {
      ...barStyle.value,
      width: '100%'
    }
    timer = setTimeout(() => {
      visible.value = false
      barStyle.value = {}
    }, 300)
  }
})

onUnmounted(() => {
  if (timer) clearTimeout(timer)
})
</script>

<style scoped>
.loading-bar {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
}
.loading-bar-fade-enter-active,
.loading-bar-fade-leave-active {
  transition: opacity 0.3s;
}
.loading-bar-fade-enter-from,
.loading-bar-fade-leave-to {
  opacity: 0;
}
</style>
